import React, { useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import NavbarComp from '../components/NavbarComp';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import FloatingCart from '../components/FloatingCart';
import { useAuth } from '../context/AuthContext';
import { useToast } from '../context/ToastProvider';
import { ADMIN_ROLES } from '../utils/permissions';


export default function MainLayout({ children }) {
  const { roleId, hasPermission } = useAuth();
  const { showToast } = useToast();
  const navigate = useNavigate();
  const latestOrderIdRef = useRef(null);

  useEffect(() => {
    if (!ADMIN_ROLES.includes(roleId) || !hasPermission('orders:read')) {
      return;
    }

    let active = true;
    let intervalId;

    const formatCurrency = (amount) =>
      new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        maximumFractionDigits: 2,
      }).format(amount || 0);

    const fetchLatestOrder = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const res = await fetch(
          `${process.env.REACT_APP_API_URL}/api/orders/admin/latest`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (!res.ok) return;
        const order = await res.json();

        if (!order?.id) return;

        if (latestOrderIdRef.current && order.id !== latestOrderIdRef.current) {
          showToast(
            {
              title: 'New Order',
              message: `#${order.id} • ${order.shipping_name || 'Unknown customer'} • ${formatCurrency(order.total_amount)} • ${order.status}`,
              bg: 'success',
              actionLabel: 'View order',
              onAction: () => navigate('/admin/orders'),
              playSound: true,
            }
          );
        }

        if (active) {
          latestOrderIdRef.current = order.id;
        }
      } catch (err) {
        console.warn('Order notification error:', err);
      }
    };

    fetchLatestOrder();
    intervalId = window.setInterval(fetchLatestOrder, 15000);

    return () => {
      active = false;
      window.clearInterval(intervalId);
    };
  }, [roleId, hasPermission, showToast, navigate]);

  return (
    <div className="app-shell">
      {/* <span className='header-banner'> This Website is under development, some features may not work as expected.</span> */}
      <NavbarComp />
      <main className="page-content">{children}</main>
      <Footer />
      <div className="fab-container">
        <FloatingCart />
        <WhatsAppButton />
      </div>      
    </div>
  );
}
